exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._2Iqc9ATQuN1sn_-qUo8zM6{padding-top:20px}", ""]);

// exports
exports.locals = {
	"userVoiceDisclaimerLabel": "_2Iqc9ATQuN1sn_-qUo8zM6"
};